import { Box, Button, CheckIcon, Flex, Typography } from '@iheartjane/reefer';

import { RatingStars } from '../../ratingStars/ratingStars';
import type { ReviewableProduct } from '../../reviewableProduct';
import { MoreToReviewList } from '../moreToReviewList/moreToReviewList';
import { RateAndReviewModal } from '../rateAndReviewModal/rateAndReviewModal';

import styles from './reviewSubmitted.module.css';

export interface ReviewSubmittedProps {
  /** Other products to review, listed below the confirmation. */
  moreToReview?: ReviewableProduct[];
  /** Footer "I'm done" action. */
  onDone: () => void;
  onReviewProduct: (product: ReviewableProduct) => void;
  productName: string;
  /** Whole-star rating the user gave (1-5). */
  rating: number;
  testId?: string;
}

/**
 * Final Rate & Review phase, shared by every A/B test variant.
 * Renders inside `RateAndReviewModal` and suggests other products to review.
 */
export function ReviewSubmitted({
  moreToReview = [],
  onDone,
  onReviewProduct,
  productName,
  rating,
  testId = 'review-submitted',
}: ReviewSubmittedProps) {
  return (
    <>
      <RateAndReviewModal.Body>
        <Flex
          alignItems="center"
          data-testid={testId}
          flexDirection="column"
          width="100%"
        >
          <Flex
            alignItems="center"
            justifyContent="center"
            background="success-light"
            className={styles['successIcon']}
            height={64}
            width={64}
          >
            <CheckIcon color="success" size="lg" />
          </Flex>
          <Typography
            as="h2"
            branded
            mt={8}
            textAlign="center"
            variant="h2-semibold"
          >
            Review submitted
          </Typography>
          <Typography color="grays-mid" mt={8} textAlign="center">
            Thank you for helping your community by reviewing {productName}
          </Typography>
          <Flex mt={8}>
            <RatingStars rating={rating} size="lg" />
          </Flex>
          {moreToReview.length > 0 && (
            <Box mt={24} width="100%">
              <MoreToReviewList
                heading={`${moreToReview.length} more to review`}
                headingLevel="h3"
                onReviewProduct={onReviewProduct}
                products={moreToReview}
                testId={testId}
              />
            </Box>
          )}
        </Flex>
      </RateAndReviewModal.Body>
      <RateAndReviewModal.Footer>
        <Button label="I'm done" onClick={onDone} variant="tertiary" />
      </RateAndReviewModal.Footer>
    </>
  );
}
